(() => {
  const query = new URLSearchParams(location.search);
  document.querySelectorAll('[data-p4x-browser]').forEach(async (root) => {
    const labels = JSON.parse(root.querySelector('[data-browser-labels]').textContent);
    const make = root.querySelector('[data-make]');
    const model = root.querySelector('[data-model]');
    const series = root.querySelector('[data-series]');
    const status = root.querySelector('[data-browser-status]');
    const results = root.querySelector('[data-results]');
    const fill = (select, values, prompt) => {
      select.replaceChildren(new Option(prompt, ''));
      [...new Set(values)].sort((a,b) => a.localeCompare(b)).forEach(value => select.add(new Option(value, value)));
      select.disabled = values.length === 0;
    };
    try {
      const response = await fetch(root.dataset.source);
      if (!response.ok) throw new Error('Vehicle collections unavailable');
      const records = await response.json();
      fill(make, records.map(r => r.make), labels.chooseMake);
      const render = () => {
        results.replaceChildren();
        const matches = records.filter(r => r.make === make.value && r.model === model.value && (!series.value || r.series === series.value));
        status.textContent = !make.value ? labels.chooseMake : !model.value ? labels.chooseModel : matches.length ? labels.results : labels.none;
        matches.forEach(record => {
          const link = document.createElement('a');
          link.href = '/collections/' + encodeURIComponent(record.handle);
          const title = document.createElement('strong'); title.textContent = record.category;
          const detail = document.createElement('span'); detail.textContent = record.series;
          link.append(title, detail); results.append(link);
        });
        const vehicle = [make.value, model.value, series.value].filter(Boolean).join(' ');
        root.querySelector('[data-browser-help]').href = '/pages/get-a-quote?' + new URLSearchParams({request:'fitted', vehicle});
        const url = new URL(location.href);
        ['make','model','series'].forEach((key,i) => { const value = [make,model,series][i].value; value ? url.searchParams.set(key,value) : url.searchParams.delete(key); });
        history.replaceState(null,'',url);
      };
      const updateSeries = () => { fill(series, records.filter(r => r.make === make.value && r.model === model.value).map(r => r.series), labels.allSeries); render(); };
      const updateModels = () => { fill(model, records.filter(r => r.make === make.value).map(r => r.model), labels.chooseModel); updateSeries(); };
      make.addEventListener('change', updateModels); model.addEventListener('change',updateSeries); series.addEventListener('change',render);
      if ([...make.options].some(o => o.value === query.get('make'))) make.value = query.get('make');
      updateModels();
      if ([...model.options].some(o => o.value === query.get('model'))) model.value = query.get('model');
      updateSeries();
      if ([...series.options].some(o => o.value === query.get('series'))) series.value = query.get('series');
      render();
    } catch (error) { status.textContent = labels.error; }
  });
  document.querySelectorAll('.p4x-enquiry-form').forEach(form => {
    const type = form.querySelector('[name="contact[Request type]"]');
    if (!type) return;
    const vehicle = form.querySelector('[data-p4x-vehicle]');
    const fields = form.querySelector('[data-vehicle-fields]');
    const fitting = form.querySelector('[data-fitting]');
    const steps = [...form.querySelectorAll('[data-build-step]')];
    const phone = form.querySelector('[name="contact[phone]"]');
    const method = form.querySelector('[data-contact-method]');
    const phoneLabel = form.querySelector('[data-phone-label]');
    const updatePhone = () => { phone.required = method.value === 'Phone'; phoneLabel.textContent = phoneLabel.dataset[phone.required ? 'required' : 'optional']; };
    method.addEventListener('change', updatePhone); updatePhone();
    if (!steps.length) {
      if (query.get('request') === 'fitted') { type.value = 'Product quote'; fitting.checked = true; }
      if (vehicle.value) fitting.checked = true;
      const update = () => {
        const needsVehicle = ['Workshop service or installation','GVM upgrade assessment','Build planning'].includes(type.value) || fitting.checked;
        fields.hidden = !needsVehicle;
        fields.disabled = !needsVehicle;
        vehicle.required = needsVehicle;
        const date = form.querySelector('[data-date-wrap]');
        date.hidden = type.value !== 'Workshop service or installation' && !fitting.checked;
        date.querySelector('input').disabled = date.hidden;
      };
      type.addEventListener('change',update); fitting.addEventListener('change',update); update();
    } else {
      const inspiration = form.querySelector('[data-build-inspiration]');
      const allowed = ['graphite-landcruiser-200-monster-build','jeep-wrangler-rubicon-jk-swb-build'];
      if (allowed.includes(query.get('inspiration'))) inspiration.value = location.origin + '/pages/' + query.get('inspiration');
      const progress = form.querySelector('[data-build-progress]');
      const back = form.querySelector('[data-build-back]');
      const next = form.querySelector('[data-build-next]');
      const submit = form.querySelector('[data-enquiry-submit]');
      let current = 0;
      const summary = () => {
        const values = [...form.querySelectorAll('[data-build-step="0"] input,[data-build-step="0"] select,[data-build-step="1"] input')].filter(input => input.type !== 'checkbox' || input.checked).filter(input => input.value);
        form.querySelector('[data-build-summary]').textContent = values.map(input => {
          const label = input.labels?.[0]?.textContent.trim().replace(/\s*\*$/, '') || input.name;
          return input.type === 'checkbox' ? input.value : label + ': ' + input.value;
        }).join('\n');
      };
      const show = (index, focus) => {
        current = index; steps.forEach((step,i) => step.hidden = i !== current);
        progress.hidden = false;
        [...progress.children].forEach((li,i) => i === current ? li.setAttribute('aria-current','step') : li.removeAttribute('aria-current'));
        back.hidden = current === 0; next.hidden = current === steps.length - 1; submit.hidden = !next.hidden;
        summary();
        if (focus) { const legend = steps[current].querySelector('legend'); legend.tabIndex = -1; legend.focus(); }
      };
      const advance = () => { const invalid = [...steps[current].querySelectorAll('input,select,textarea')].find(input => !input.checkValidity()); if (invalid) invalid.reportValidity(); else show(Math.min(current+1,steps.length-1),true); };
      next.addEventListener('click',advance); back.addEventListener('click',() => show(Math.max(0,current-1),true));
      form.addEventListener('keydown',event => { if(event.key === 'Enter' && event.target.tagName === 'INPUT' && current < steps.length-1){event.preventDefault();advance();} });
      form.addEventListener('invalid',event => { const step = event.target.closest('[data-build-step]'); if(step) show(Number(step.dataset.buildStep),false); },true);
      show(0,false);
    }
  });
  const canonical = (value, colour) => {
    let key = value.trim().toLowerCase().replace(/[\s_:\-]+/g,'');
    if (colour) { key=key.replace(/grey/g,'gray'); return ({cerakoteblack:'blackcerakote',powdercoattextureblack:'blacktexturepowdercoat'})[key] || key; }
    const aliases = {mantaperformance:'manta',mcc4x4accessories:'mcc4x4',ultravisionlighting:'ultravision',msa4x4accessories:'msa4x4',rsismartcanopy:'rsi'};
    return aliases[key] || key;
  };
  const brandNames = {alucab:'Alu-Cab',carbonoffroad:'Carbon Offroad',fox:'FOX',gmf4x4:'GMF4X4',manta:'Manta Performance',mcc4x4:'MCC 4x4',msa4x4:'MSA 4x4 Accessories',rsi:'RSI SmartCanopy',offroadanimal:'Offroad Animal',oricom:'ORICOM',outbackkitters:'Outback Kitters',pro4x4:'PRO4x4',runva:'Runva',ultravision:'Ultra Vision',utemaster:'Utemaster',oztent:'Oztent',powerbox:'Power Box',superiorengineering:'Superior Engineering',travelbuddy:'Travel Buddy'};
  const groupsByInput = new WeakMap();
  const cleanFilters = () => {
    document.querySelectorAll('[data-p4x-filter]:not([data-p4x-ready])').forEach(group => {
      group.dataset.p4xReady = 'true';
      const label = group.dataset.p4xFilter.toLowerCase();
      const colour = /colou?r/.test(label);
      if (!colour && !/brand|vendor/.test(label)) return;
      const groups = new Map();
      group.querySelectorAll('input[type=checkbox]').forEach(input => { const key = canonical(input.value,colour); if(!groups.has(key)) groups.set(key,[]); groups.get(key).push(input); });
      const rows = [];
      groups.forEach((inputs,key) => {
        const primary = inputs.find(input => !input.disabled) || inputs[0];
        const row = primary.closest('label'); rows.push(row);
        const checked = inputs.some(input => input.checked); primary.checked = checked;
        inputs.forEach(input => { groupsByInput.set(input,inputs); if(input !== primary) input.closest('label').classList.add('p4x-filter-alias'); });
        if(inputs.length > 1) row.querySelector('.filter-group__item__count')?.remove();
        const display = colour ? primary.value.trim().toLowerCase().replace(/\b\w/g,letter=>letter.toUpperCase()).replace(/Gray/g,'Grey') : brandNames[key];
        if (display) { const text = row.querySelector('.filter-group__item__text'); const node = [...text.childNodes].find(node => node.nodeType === 3); if(node) node.textContent = display; }
        row.classList.toggle('filter-group__item--active',checked);
      });
      if(rows.length > 8) {
        const labelEl = document.createElement('label'); labelEl.className = 'p4x-filter-search'; labelEl.textContent = group.dataset.searchLabel;
        const search = document.createElement('input'); search.type='search'; search.autocomplete='off'; labelEl.append(search);
        group.querySelector('.toggle-target-container').prepend(labelEl);
        search.addEventListener('input',event => { event.stopPropagation(); const term = search.value.trim().toLowerCase(); rows.forEach(row => row.hidden = !row.textContent.toLowerCase().includes(term)); });
        search.addEventListener('change',event => event.stopPropagation());
        search.addEventListener('keydown',event => { if(event.key==='Enter') event.preventDefault(); });
      }
    });
    const chips = new Map();
    document.querySelectorAll('[data-filter-name]:not([data-p4x-ready])').forEach(chip => {
      chip.dataset.p4xReady='true';
      const name=chip.dataset.filterName; const colour=/colou?r/i.test(name);
      if(!colour && !/vendor|brand/i.test(name)) return;
      const key=canonical(chip.dataset.filterValue,colour); const id=name+'|'+key;
      if(chips.has(id)){chip.classList.add('p4x-filter-alias');return;}
      chips.set(id,chip);
      const display = colour ? chip.dataset.filterValue.trim().toLowerCase().replace(/\b\w/g,letter=>letter.toUpperCase()).replace(/Gray/g,'Grey') : brandNames[key];
      if(display) chip.querySelector('.filter-group__applied-item__text').textContent=display;
      const url=new URL(chip.href,location.origin);
      const values=url.searchParams.getAll(name).filter(value=>canonical(value,colour)!==key);
      url.searchParams.delete(name); values.forEach(value=>url.searchParams.append(name,value)); chip.href=url.pathname+url.search;
    });
  };
  document.addEventListener('change',event=>{const inputs=groupsByInput.get(event.target);if(inputs)inputs.forEach(input=>{if(!input.disabled)input.checked=event.target.checked;});},true);
  cleanFilters();
  if(document.querySelector('#CollectionFilterForm')) { let pending=false; new MutationObserver(()=>{if(!pending){pending=true;requestAnimationFrame(()=>{pending=false;cleanFilters();});}}).observe(document.querySelector('main')||document.body,{childList:true,subtree:true}); }
})();
